import { z } from 'zod';

export const vehicleStatusSchema = z.enum(['active', 'pending', 'busy', 'maintenance', 'inactive']);
/**
 * the current vehicle status:
 * - `active` = means the vehicle is ready to accept orders
 * - `busy` = means the vehicle is delivering some order
 * - `maintenance` = means the vehicle is having some maintenance
 * - `pending` = means needs review
 * - `inactive` = means the something is wrong with the vehicle such as there is no driver
 */
export type VehicleStatus = z.infer<typeof vehicleStatusSchema>;
